import type { Claim, Prize, Schedule, ScheduleRequest, Winners } from '@/models/interface/lottery';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class LotteryService extends ApiFactory {
  constructor() {
    super('Lottery');
  }

  /**
   * 取得抽獎期數
   * @param data
   * @returns
   */
  getScheduleList(data: ScheduleRequest): Promise<ApiDataResponse<Schedule>> {
    return this.post(`Schedule`, data);
  }

  /**
   * 取得當期獎金名單
   * @param lotteryId
   * @param page
   * @param size
   * @returns
   */
  getPrizesList(lotteryId: number, page?: number, size?: number): Promise<ApiDataResponse<Prize>> {
    return this.get(`${lotteryId}/Prizes?Page=${page}&Size=${size}`);
  }

  /**
   * 取得得獎者名單
   * @param lotteryId
   * @param page
   * @param size
   * @returns
   */
  getWinnersList(
    lotteryId: number,
    page?: number,
    size?: number
  ): Promise<ApiDataResponse<Winners>> {
    return this.get(`${lotteryId}/Winners?Page=${page}&Size=${size}`);
  }

  /**
   * 激活領獎票券
   * @param winnerId 
   * @returns 
   */
  claim(winnerId: number): Promise<ApiDataResponse<Claim>> {
    return this.put(`Winner/${winnerId}/Claim`, null);
  }

  /**
   * 填寫完表單後送出改狀態
   * @param winnerId 
   * @returns 
   */
  applyDone(winnerId: number): Promise<ApiDataResponse<Claim>> {
    return this.put(`Winner/${winnerId}/ClaimFormSubmission`, null);
  }
}
